// null = out-of-range OR span end not yet streamed (streaming partial guard)
export function codePointToUtf16(content: string, cpIndex: number): number | null {
  if (cpIndex < 0) return null;
  let cpCount = 0;
  let unit = 0;
  for (const cp of content) {
    if (cpCount === cpIndex) return unit;
    cpCount++;
    unit += cp.length;
  }
  // cpCount === total code points; cpIndex === cpCount is the valid end boundary
  if (cpIndex === cpCount) return unit;
  return null;
}
